<template>
  <div>
    <success-fade-alert ref="alertSuccess" :msg="alert.success" />
    <fade-alert-danger ref="alertDanger" :msg="alert.error" />

    <b-row>
      <h2>
        {{ this.$t("vehicleAvailableReason.edit") }}
      </h2>
    </b-row>

    <b-row>
      <b-button @click="voltar()" size="sm">
        {{ $t("geral.back") }}
      </b-button>
    </b-row>

    <b-row class="mt-2">
      <b-col lg="6" md="6" sm="6">
        <vehicle-available-reason :model="model" :modelstate="modelstate" />
      </b-col>
    </b-row>

    <b-row style="margin-top: 40px">
      <b-button @click="save" size="sm">
        {{ $t("geral.save") }}
      </b-button>
    </b-row>
  </div>
</template>

<script>
export default {
  components: {
    "vehicle-available-reason": () =>
      import(
        "@/components_rms/vehicle/VehicleAvailableReason/VehicleAvailableReason.vue"
      ),
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
  },
  data() {
    return {
      modelstate: {},
      alert: {
        error: "Erro ao criar registro: ",
        success: "Registro editado com sucesso",
      },
      model: {
        name: null,
        availabilityReason: null,
      },
    };
  },

  mounted() {
    this.getVehicleAvailableReason();
  },
  methods: {
    save() {
      this.modelstate = {};
      let obj = {
        id: this.$route.params.id,
        name: this.model.name,
        availabilityReason: this.model.availabilityReason,
      };
      this.$apiVehicle
        .put("/vehicleAvailableReason/edit", obj)
        .then((response) => {
          if (response.data.status == 500) {
            this.alert.error = response.data.title;
            this.$refs.alertDanger.show();
          } else {
            this.$refs.alertSuccess.show();
          }
        })
        .catch((error) => {
          if (error.response.data.errorCode === 400) {
            this.alert.error = error.response.data.errorMessage;
            this.$refs.alertDanger.show();
          }
          if (error.response.status == 400) {
            this.modelstate = error.response.data.errors;
          }
        });
    },
    getVehicleAvailableReason() {
      this.$apiVehicle
        .get(`/vehicleAvailableReason/get/${this.$route.params.id}`)
        .then((response) => {
          this.model = response.data;
        })
        .catch((error) => {
          console.log(error.response);
        });
    },
    voltar() {
      this.$router.go(-1);
    },
  },
};
</script>